import { AppShell } from "./components/AppShell";
import { PageLoader } from "./components/ui";
import { useAuth } from "./context/AuthContext";
import { Redirect, useRouter } from "./lib/router";
import { rememberReturnPath } from "./lib/returnPath";
import { DashboardPage } from "./pages/DashboardPage";
import { ActivateFirstAccessPage, FirstAccessPage } from "./pages/FirstAccessPage";
import { LoginOtpPage } from "./pages/LoginOtpPage";
import { LoginPage } from "./pages/LoginPage";
import { NewTicketPage } from "./pages/NewTicketPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import {
  PasswordResetConfirmPage,
  PasswordResetRequestPage,
} from "./pages/PasswordResetPage";
import { TicketDetailPage } from "./pages/TicketDetailPage";
import { TicketsPage } from "./pages/TicketsPage";
import { UserManagementPage } from "./pages/UserManagementPage";

function ProtectedArea({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isReady } = useAuth();
  const { pathname } = useRouter();

  if (!isReady) return <PageLoader />;
  if (!isAuthenticated) {
    rememberReturnPath(pathname);
    return <Redirect to="/login" />;
  }

  return <AppShell>{children}</AppShell>;
}

export function App() {
  const { pathname } = useRouter();
  const { isAuthenticated, session } = useAuth();

  if (pathname === "/login") {
    return isAuthenticated ? <Redirect to="/" /> : <LoginPage />;
  }
  if (pathname === "/login/verificacao") {
    return isAuthenticated ? <Redirect to="/" /> : <LoginOtpPage />;
  }
  if (pathname === "/primeiro-acesso") {
    return isAuthenticated ? <Redirect to="/" /> : <FirstAccessPage />;
  }
  if (pathname === "/primeiro-acesso/ativar") {
    return isAuthenticated ? <Redirect to="/" /> : <ActivateFirstAccessPage />;
  }
  if (pathname === "/recuperar-senha") {
    return isAuthenticated ? <Redirect to="/" /> : <PasswordResetRequestPage />;
  }
  if (pathname === "/recuperar-senha/confirmar") {
    return isAuthenticated ? <Redirect to="/" /> : <PasswordResetConfirmPage />;
  }

  let page: React.ReactNode;
  if (pathname === "/") page = <DashboardPage />;
  else if (pathname === "/chamados") page = <TicketsPage />;
  else if (pathname === "/chamados/novo") page = <NewTicketPage />;
  else if (pathname === "/usuarios") {
    page = session?.podeGerenciarUsuarios
      ? <UserManagementPage />
      : <NotFoundPage />;
  }
  else {
    const detail = pathname.match(/^\/chamados\/(\d+)$/);
    page = detail ? <TicketDetailPage ticketId={detail[1]} /> : <NotFoundPage />;
  }

  return <ProtectedArea>{page}</ProtectedArea>;
}
